function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import Accordion from '@mozaic-ds/freemarker/js/modules/_accordion.js';
export var ProductInformations = /*#__PURE__*/function () {
  function ProductInformations(element) {
    _classCallCheck(this, ProductInformations);
    this.myAccordions = element.querySelectorAll('.js-accordion');
    this.seeMoreCharacteristics = document.querySelector('.w-main-characteristics__link');
    this.characteristicsAccordion = element.querySelector('.js-accordion.o-product-detail-informations__item');
  }
  return _createClass(ProductInformations, [{
    key: "initAccordion",
    value: function initAccordion() {
      var _this = this;
      this.myAccordions.forEach(function (accordion) {
        new Accordion(accordion);
      });
      if (this.seeMoreCharacteristics) {
        this.seeMoreCharacteristics.addEventListener('click', function () {
          _this.characteristicsAccordion.querySelector('.js-accordion__trigger').click();
          window.scrollTo({
            top: _this.characteristicsAccordion.offsetTop,
            behavior: 'smooth'
          });
        });
      }
    }
  }]);
}();
export default ProductInformations;